import React from "react";
import CardAdminXervix from "./components/card_admin";
import Sidebar from "./components/sidebar_admin";
import { Link } from "react-router-dom";
import TableRequestResume from "./components/table_soliciudes_resumen";

const AdminRequestResume: React.FC = () => {
  return (
    <div className="flex p-6 bg-gray-50 min-h-screen">
    <Sidebar />
<div className="ml-10 w-full"> 
<div className="flex justify-end text-sm mt-10 mb-8">    
      <Link to="/admin/solicitudes" className="px-4"><span>Solicitudes</span></Link>
      <Link to="/admin/request/close" className="px-4"><span>Servicios</span></Link>
      <Link to="/admin/request/resume" className="px-4"><span>Resumen</span></Link>
    </div>  

    <div className="mt-8 grid grid-cols-2 gap-4 mb-8">
        <div className="px-4 py-8 bg-pink-100 text-center rounded-lg shadow">
          <h3 className="text-lg font-semibold">Servicios activos totales</h3>
          <p className="text-xl font-bold">2651</p>
        </div>
        <div className="px-4 py-8 bg-green-100 text-center rounded-lg shadow">
          <h3 className="text-lg font-semibold">Solicitudes totales</h3>
          <p className="text-xl font-bold">6.658</p>
        </div>
                  
      </div>            
    
     <TableRequestResume />
   </div>

 </div>   
  );
};

export default AdminRequestResume;